import React, { useMemo } from "react";
import style from "./index.module.scss";
import { getVoteFilter, StuVoteItem, VoteContent } from "service/vote";
import { ColumnProps } from "antd/lib/table/interface";
import moment from "moment";
import { Table } from "antd";
import VoteSelect from "./components/VoteSelect";

interface VoteStuTableProp {
    voteInfo: VoteContent;
    stuList: StuVoteItem[];
}

export default function VoteStuTable({ voteInfo, stuList }: VoteStuTableProp) {
    const filters = useMemo(
        () => getVoteFilter(voteInfo.type, voteInfo.answersNumber, stuList),
        [voteInfo, stuList]
    );

    function onFilterStatus(value: any, record: StuVoteItem) {
        if (value === "--" && record.voteStatus === "0") return true; // 未投票
        const selected = record.voteInfo?.map(item => item.content) || [];
        return selected.includes(value);
    }

    const columns: ColumnProps<StuVoteItem>[] = [
        {
            title: "班级",
            dataIndex: "className",
            align: "center",
            width: 300
        },
        {
            title: "学生信息",
            dataIndex: "name",
            render: renderStudent
        },
        {
            title: "投票情况",
            dataIndex: "voteStatus",
            render: (voteStatus: string, item) => (
                <VoteSelect voteInfo={voteInfo} data={item} />
            ),
            align: "center",
            width: 140,
            filters: filters,
            onFilter: (value, record) => onFilterStatus(value, record)
        },
        {
            title: "投票时间",
            dataIndex: "voteTime",
            align: "center",
            width: 200,
            render: (text: string) =>
                text ? moment(text).format("MM-DD HH:mm:ss") : "",
            sorter: (itemA, itemB) =>
                itemA.voteTime > itemB.voteTime ? 1 : -1,
            sortDirections: ["ascend", "descend"]
        }
    ];

    // 学生信息
    function renderStudent(text: string, item: StuVoteItem) {
        return (
            <div className={style.student}>
                {text}
                <span className={style.stuNo}>{item.studentNo}</span>
            </div>
        );
    }

    function getContainer(): any {
        return document.querySelector(".PopupContainer");
    }

    return (
        <div className={style.root}>
            <Table
                getPopupContainer={getContainer}
                columns={columns}
                dataSource={stuList}
                rowKey="studentNo"
                pagination={false}
                scroll={{ y: "calc(100vh - 350px)" }}
            />
        </div>
    );
}
